<mat-dialog-content class="modal-header"
  ><h2 mat-dialog-title>TIPO VISITA PARA CONTRATISTAS</h2></mat-dialog-content>

  <mat-dialog-content class="modal-body">
    <div class="block-content">
        <div class="form-horizontal">
            <div class="form-group">
                <label class="col-md-3 control-label">Tipo Visita Default:</label>
                <div class="col-md-9">
                    <mat-form-field
            class="example-full-width"
            appearance="outline">
            <mat-label>Seleccione:</mat-label>
            <mat-select matSelect [(ngModel)]="idDefault">
                <mat-option *ngFor="let item of model.items; index as i;" [value]='item.idTipoVisita'>{{item.nombre}}</mat-option>
              </mat-select>
          </mat-form-field>
                </div>
            </div>
        </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="modal-actions">
    <!-- <button type="submit" class="btn btn-naranja" [disabled]="modelForm.invalid" [mat-dialog-close]="model" mat-button cdkFocusInitial>Guardar</button> -->
    <button
      class="btn btn-naranja"
      mat-button
      
      (click)="Save()"
      [disabled]="idDefault==0"
      cdkFocusInitial
    >
      Guardar
    </button>
    <button type="button" class="btn btn-celeste" mat-button (click)="onNoClick()">Cancelar</button>
  </mat-dialog-actions>